export enum AbaEnum {
  Agenda,
  DadosAtendimento,
  Evolucao,
  Prescricao,
  PedidosExames,
  Encaminhamento,
  Atestados,
  ProntuariosAvulsos,
  Chat
}
